var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-autocomplete',{attrs:{"dense":"","loading":_vm.loading,"items":_vm.items,"return-object":"","chips":"","deletable-chips":"","clearable":"","item-value":"id","tags":"","disabled":_vm.myself,"rules":_vm.required ? [(v) => !!v] : [],"multiple":_vm.multiple,"label":_vm.label,"item-text":(item) => {
        return _vm.itemText(item)
      }},on:{"change":_vm.onChange},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }